import Svg, { Defs, G, LinearGradient, Path, Stop } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const ProtectAccountSmall = ({ color = '#0F3CC9', textColor = '#8DA8FF' }) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={28} height={29} fill="none">
    <G filter="url(#a)">
      <Path
        fill={color}
        d="M14.412.29 3.135 5.074s-.638 6.499.656 12.566C5.085 23.708 14.412 28 14.412 28s9.114-4.34 10.457-10.36c1.342-6.02.643-12.566.643-12.566L14.412.29Z"
      />
    </G>
    <Path
      fill={textColor}
      d="m14.394 3.393-8.75 3.713a36.575 36.575 0 0 0 .508 9.75c1.003 4.708 8.242 8.038 8.242 8.038s7.071-3.367 8.112-8.038c1.042-4.67.5-9.75.5-9.75l-8.612-3.713Z"
    />
    <Path
      fill="#fff"
      d="M17.255 11.472h-.47v-1.13a2.083 2.083 0 0 0-.33-1.136 2.392 2.392 0 0 0-.894-.829 2.543 2.543 0 0 0-1.237-.308 2.543 2.543 0 0 0-1.237.308 2.39 2.39 0 0 0-.895.829c-.217.34-.332.734-.33 1.136v1.13h-.47a1.162 1.162 0 0 0-.843.347 1.138 1.138 0 0 0-.349.834v5.236a1.166 1.166 0 0 0 .349.835 1.19 1.19 0 0 0 .844.345h5.861a1.2 1.2 0 0 0 .845-.344 1.177 1.177 0 0 0 .348-.836v-5.236a1.126 1.126 0 0 0-.349-.834 1.15 1.15 0 0 0-.843-.347Zm-4.593-1.13a1.328 1.328 0 0 1 .222-.74c.152-.23.361-.416.608-.54.257-.134.542-.203.831-.202.29-.001.575.068.831.201.248.125.457.31.61.54.145.22.222.478.22.741v1.13h-3.322v-1.13Zm2.575 4.922a.864.864 0 0 1-.266.642.924.924 0 0 1-1.494-.29.858.858 0 0 1-.067-.345.878.878 0 0 1 .267-.642.906.906 0 0 1 .998-.2.906.906 0 0 1 .296.2.877.877 0 0 1 .267.635Z"
    />
    <Path
      fill="url(#b)"
      d="M3.136 5.052 14.42.38v27.512s-5.837-2.598-8.712-6.375c-2.792-3.667-2.573-8.671-2.573-8.671l-.22-3.897.22-3.897Z"
      opacity={0.6}
    />
    <Path
      fill="#fff"
      d="m5.745 4.913.432 1.893 1.366.597-1.366.598-.432 1.891-.43-1.89-1.367-.598 1.366-.598.431-1.893ZM7.933 3.613l.326 1.235 1.034.39-1.034.39-.326 1.233-.326-1.233-1.034-.39 1.034-.39.326-1.235Z"
    />
    <Defs>
      <LinearGradient id="b" x1={5.839} x2={22.914} y1={2.608} y2={11.404} gradientUnits="userSpaceOnUse">
        <Stop stopColor="#fff" stopOpacity={0.67} />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.06} />
      </LinearGradient>
    </Defs>
  </Svg>
)
export { ProtectAccountSmall }
